import {
  NewSampleRequest,
  Sample,
} from "@/services/backend/samples/types/sample";

export type WaterKind = "warm" | "cold";

export interface WaterSample extends Sample {
  waterKind: WaterKind;
  desinfected: boolean;
  temperature: number;
  measurements: Measurement[];
}

export interface Measurement {
  order: number;
  waterSampleId: string;
  name: string;
  value: string;
  referenceValue: string;
  unit: string;
}

/** Creates a water sample of the water kind, see {@link NewSampleRequest}. */
export interface NewWaterSampleRequest extends NewSampleRequest {
  waterKind: WaterKind;
}

export function updateTemperature(
  sample: WaterSample,
  temperature: number,
): WaterSample {
  return {
    ...sample,
    temperature,
  };
}

export function updateMeasurement(
  sample: WaterSample,
  measurement: Measurement,
): WaterSample {
  const measurements = sample.measurements.map((m) =>
    m.order === measurement.order ? measurement : m,
  );
  return {
    ...sample,
    measurements,
  };
}
